export const PLANNED_FIELDS = [
  "salary_planned",
  "taxes_planned",
  "rent_planned",
  "supplies_planned",
  "travel_planned",
  "fixed_assets_planned",
  "software_planned",
  "gph_planned",
  "msb_services_planned",
  "other_services_planned",
] as const;

export type PlannedField = (typeof PLANNED_FIELDS)[number];

export const PLANNED_LABELS: Record<PlannedField, string> = {
  salary_planned: "projectForm.fields.salaryPlanned",
  taxes_planned: "projectForm.fields.taxesPlanned",
  rent_planned: "projectForm.fields.rentPlanned",
  supplies_planned: "projectForm.fields.suppliesPlanned",
  travel_planned: "projectForm.fields.travelPlanned",
  fixed_assets_planned: "projectForm.fields.fixedAssetsPlanned",
  software_planned: "projectForm.fields.softwarePlanned",
  gph_planned: "projectForm.fields.gphPlanned",
  msb_services_planned: "projectForm.fields.msbServicesPlanned",
  other_services_planned: "projectForm.fields.otherServicesPlanned",
};

export function stripTrailingZeros(value: string | null | undefined): string {
  if (!value) return "";
  return value.includes(".") ? value.replace(/\.?0+$/, "") : value;
}
